export default __webpack_public_path__ + "static/media/factory.4506f446.png";